import React from 'react';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import ProposalInfoSection from 'components/common/proposal/ProposalInfoSection';
import { ActionModal, Button } from '@insurancemenu/imenu-components-lib';
import { DollarCircle, Edit, Tools } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useHistory } from 'react-router-dom';
import { uwRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { createStyles } from './styles';

const MainInfoPanel: React.FC = observer(() => {
  const {
    proposalItemsStore: {
      group,
      proposal,
      cart,
      enrollmentPeriod,
      isMutableProposal,
      catalog,
      editProposal,
      copyCartAndInitiateProposal,
    },
    userStore: { userRoles },
    domainStoreV2: { groupInitiationRedirect },
  } = useRootStore();

  const history = useHistory();
  const [showFailingModal, setShowFailingModal] = React.useState(false);
  const proposalName = proposal.name;

  const proposalPanelInfo = {
    'Agent of Record': group.agentOfRecord?.name || '',
    'Effective Date':
      enrollmentPeriod && dateFormatters.normDateToShortAmericanDate(cart.lastUpdateBrowsingCriteria.effectiveDate),
    Location: `${cart.lastUpdateBrowsingCriteria.county}, ${cart.lastUpdateBrowsingCriteria.state} ${cart.lastUpdateBrowsingCriteria.zipCode}`,
    'Created On': proposal?.createdOn ? dateFormatters.normDateToShortAmericanDate(proposal.createdOn) : '',
    'Created By': proposal?.createdBy?.name || '',
    'Last modified':
      cart.lastUpdateTime?.length > 0 ? dateFormatters.normDateToAmericanDateTime(cart.lastUpdateTime) : '',
  };

  function onGenerateProposal(): void {
    history.push(
      `/generate-proposal/choose-the-way/${enrollmentPeriod.id}?cartId=${proposal.cartId}&groupId=${enrollmentPeriod.groupId}&catalogId=${catalog.id}&cartName=${proposal.name}&proposalType=SHELF`,
    );
  }

  function onOverrideRates(): void {
    history.push(
      `/proposal-override-rates/${enrollmentPeriod.id}?groupId=${enrollmentPeriod.groupId}&cartId=${proposal.cartId}`,
    );
  }

  const copyProposal = async (): Promise<void> => {
    if (groupInitiationRedirect) {
      await copyCartAndInitiateProposal();
    } else {
      await editProposal();
    }
  };

  const classes = createStyles();
  return (
    <section className={classes.mainInfoPanel}>
      <ProposalInfoSection
        title={proposalName}
        mainInfo={proposalPanelInfo}
        actions={
          <>
            {isMutableProposal && (
              <>
                <Button type="text" uppercase color="primary" leftIconProp={<Edit />} onClick={copyProposal}>
                  Edit Proposal
                </Button>
                {uwRights(userRoles) && (
                  <Button
                    type="text"
                    color="primary"
                    leftIconProp={<DollarCircle />}
                    uppercase
                    onClick={onOverrideRates}
                  >
                    Override Rates
                  </Button>
                )}
              </>
            )}
            <Button type="text" uppercase color="primary" leftIconProp={<Tools />} onClick={onGenerateProposal}>
              Generate Proposal
            </Button>
          </>
        }
      />
      <ActionModal
        show={showFailingModal}
        onClose={(): void => {
          setShowFailingModal(false);
        }}
        title="Something went wrong, please try again"
        subtitle={
          <p>
            If you still have issues, please send an email to <br />
            <a href="mailto:support@insurancemenu.com">support@insurancemenu.com</a>
          </p>
        }
      />
    </section>
  );
});

export default MainInfoPanel;
